import PropTypes from "prop-types";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
// @mui
import { Box, Drawer, Stack } from "@mui/material";
// hooks
import useResponsive from "../../../hooks/useResponsive";
// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// config
import { NAV } from "../../../config-global";
// components
import Logo from "../../../components/logo";
import { NavSectionVertical } from "../../../components/nav-section";
import Scrollbar from "../../../components/scrollbar";
//
import navConfig from "./config-navigation";
import directorNavConfig from "./director-navigation";
import excutiveNavConfig from "./excutive-navigation";
import leadNavConfig from "./leads-navigation";
import managerNavConfig from "./manager-navigation";
import NavToggleButton from "./NavToggleButton";
import riderNavConfig from "./rider-navigation";
//
import { useSelector } from "react-redux";
import { useAuthContext } from "../../../auth/useAuthContext";

// ----------------------------------------------------------------------

NavVertical.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function NavVertical({ openNav, onCloseNav }) {
  // Logic here to get current user role
  const { user } = useAuthContext();

  // const currentRole = 'user';
  // const currentRole = user.roles[0].name; // admin;
  const currentRole = user?.user?.role?.name || user?.role?.name || "Admin"; // admin;

  const { categories } = useSelector((state) => state.category);

  const { pathname } = useLocation();

  const isDesktop = useResponsive("up", "lg");

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const roleConfigMap = {
    Admin: navConfig,
    Staff: navConfig,
    Executive: excutiveNavConfig,
    Manager: managerNavConfig,
    Leads: leadNavConfig,
    Director: directorNavConfig,
    Rider: riderNavConfig,
  };

  // Select the appropriate config based on the currentRole
  const selectedConfig = roleConfigMap[currentRole] || navConfig;

  const parentCategories =
    categories?.data?.filter((cat) => cat.parent_id === null) || [];

  const augmentedConfig = selectedConfig.map((group) => {
    // Filter items based on Staff role restrictions
    const filteredItems = group.items.filter((item) => {
      if (currentRole === "Staff") {
        if (item.title === "Users" || item.title === "Activity Logs") {
          return false;
        }
      }
      return true;
    });

    const processedItems = filteredItems.map((item) => {
      if (group.subheader === "Order Management") {
        if (item.title === "Orders" || item.title === "Orders List") {
          const children = item.children
            ? [...item.children]
            : [{ title: "Orders List", path: item.path }];
          return {
            ...item,
            title: "Orders",
            path: PATH_DASHBOARD.orders.root,
            children: [
              ...parentCategories.map((cat) => ({
                title: cat.name,
                path: `${PATH_DASHBOARD.orders.list}?category=${cat.slug}`,
              })),
              ...children,
            ],
          };
        }
      }

      if (group.subheader === "Stock Management") {
        if (item.title === "Stock Histories") {
          const children = item.children ? [...item.children] : [];
          return {
            ...item,
            children: [
              ...parentCategories.map((cat) => ({
                title: cat.name,
                path: `${PATH_DASHBOARD.stockHistories}?category=${cat.slug}`,
              })),
              ...children,
            ],
          };
        }
      }

      return item;
    });

    return {
      ...group,
      items: processedItems,
    };
  });

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        "& .simplebar-content": {
          height: 1,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <Stack
        spacing={3}
        sx={{
          pt: 3,
          pb: 2,
          px: 2.5,
          flexShrink: 0,
        }}
      >
        <Logo />
      </Stack>
      <div
        style={{
          paddingBottom: "25px",
        }}
      >
        <NavSectionVertical data={augmentedConfig} />
      </div>
      <Box sx={{ flexGrow: 1 }} />

      {/* <NavDocs /> */}
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD },
      }}
    >
      <NavToggleButton />

      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              zIndex: 0,
              width: NAV.W_DASHBOARD,
              bgcolor: "transparent",
              borderRightStyle: "dashed",
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: {
              width: NAV.W_DASHBOARD,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
